/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { TableColumn } from 'src/app/shared/data-table/datasource/datasource';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import {
  MatListModule,
  MatSelectionList,
  MatSelectionListChange,
} from '@angular/material/list';
import { L10nLocale, L10N_LOCALE, L10nTranslatePipe } from 'angular-l10n';

type CustomizedColumns = {
  availableColumns: TableColumn<object>[];
  displayedColumns: string[];
};

@Component({
  selector: 'app-customize-columns-dialog',
  templateUrl: './customize-columns-dialog.component.html',
  styleUrls: ['./customize-columns-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [FormsModule, DragDropModule, MatDialogModule, MatListModule, MatIconModule, MatButtonModule, L10nTranslatePipe],
})
export class CustomizeColumnsDialogComponent {
  readonly data = inject<CustomizedColumns>(MAT_DIALOG_DATA);
  readonly locale = inject<L10nLocale>(L10N_LOCALE);

  @ViewChild('columns') selectedColumns: MatSelectionList;

  get filteredAvailableColumns(): TableColumn<object>[] {
    return this.data.availableColumns.filter(
      (c) => !this.data.displayedColumns.includes(c.field)
    );
  }

  dropSelectedColumn(event: CdkDragDrop<unknown>) {
    if (event.container === event.previousContainer) {
      moveItemInArray(this.data.displayedColumns, event.previousIndex, event.currentIndex);
    }
  }

  onColumnSelected(event: MatSelectionListChange) {
    if (event.options[0]?.selected) {
      this.data.displayedColumns = [...this.data.displayedColumns, event.options[0].value.field];
    } else {
      this.data.displayedColumns = this.data.displayedColumns.filter((c) => c !== event.options[0].value.field);
    }
  }

  isSelected(column: TableColumn<object>) {
    return this.data.displayedColumns.includes(column.field);
  }

  getName(column: string) {
    const c = this.data.availableColumns.find((c) => c.field === column);
    return c?.localizationKey ?? c?.field;
  }

  isLocked(column: string) {
    return this.data.availableColumns.find((c) => c.field === column)?.locked;
  }
}
